import * as React from 'react';
import { isfunc } from 'piral-base';
/**
 * The React component for catching errors and displaying error information.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
        };
    }
    componentDidCatch(error) {
        const { onError } = this.props;
        if (isfunc(onError)) {
            onError(error);
        }
        this.setState({
            error,
        });
    }
    render() {
        const { children, renderError, renderChild, renderProps } = this.props;
        const { error } = this.state;
        if (error) {
            if (isfunc(renderError)) {
                return renderError(error, renderProps);
            }
            return React.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, error && error.message);
        }
        return isfunc(renderChild) ? renderChild(children, renderProps) : children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map